import api from './api';
import { CourseContainer } from '../types';

class CourseContainerService {
  async getContainers(parentId: number | null = null): Promise<CourseContainer[]> {
    const params = parentId === null ? { parent: 'null' } : { parent: parentId };
    const response = await api.get('/course-containers/', { params });
    // Handle paginated response
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainer(id: number): Promise<CourseContainer> {
    const response = await api.get(`/course-containers/${id}/`);
    return response.data;
  }

  async getContainerContents(id: number): Promise<{ containers: CourseContainer[], courses: any[] }> {
    const response = await api.get(`/course-containers/${id}/contents/`);
    return response.data;
  }

  async createContainer(data: Partial<CourseContainer>): Promise<CourseContainer> {
    const response = await api.post('/course-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<CourseContainer>): Promise<CourseContainer> {
    const response = await api.patch(`/course-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/course-containers/${id}/`);
  }

  async reorderContainers(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/course-containers/reorder/', { items });
  }
}

const courseContainerService = new CourseContainerService();
export default courseContainerService;